import React, { useEffect, useState } from 'react';

import { SubtleAlertModal } from './components/SubtleAlertModal';
import { StrongAlertModal } from './components/StrongAlertModal';
import useOldVersionAlertConfig from './services/useOldVersionAlertConfig';

/**
 * 客户端XP系统使用商家升级引导
 */
const OldVersionAlert: React.FC = () => {
    const {
        showSubtleAlertModal,
        showStrongAlertModal,
        subtleCountdown,
        onSubtleAlertConfirm,
    } = useOldVersionAlertConfig();
    const [currentHash, setCurrentHash] = useState(window.location.hash);

    useEffect(() => {
        const handleHashChange = () => {
            setCurrentHash(window.location.hash);
        };

        window.addEventListener('hashchange', handleHashChange);
        return () => window.removeEventListener('hashchange', handleHashChange);
    }, []);

    // 首页和加载过程中才展示弹窗
    if (
        currentHash === '' ||
        currentHash === '#/new_fe/business#/index' ||
        currentHash === '#/v2/index'
    ) {
        return (
            <>
                <SubtleAlertModal
                    visible={showSubtleAlertModal}
                    countdown={subtleCountdown}
                    onConfirm={onSubtleAlertConfirm}
                />
                <StrongAlertModal visible={showStrongAlertModal} />
            </>
        );
    }
    return null;
};

export default OldVersionAlert;
